import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=3b5aa28e&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b5aa28e')) {
      api.createRecord('3b5aa28e', component.options)
    } else {
      api.reload('3b5aa28e', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=3b5aa28e&", function () {
      api.rerender('3b5aa28e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/zhaopin/detail.vue"
export default component.exports